import { MessageClass } from '../../types/private';

export function hasAssociatedErrors(state: MessageClass) {
    return Object.keys(state.fieldMessages).length > 0;
}

export function hasUnassociatedErrors(state: MessageClass) {
    return state.messages.length > 0;
}
